import { render } from "./PasswordForgot.vue?vue&type=template&id=6eb48072&scoped=true"
import script from "./PasswordForgot.vue?vue&type=script&lang=js"
export * from "./PasswordForgot.vue?vue&type=script&lang=js"

import "./PasswordForgot.vue?vue&type=style&index=0&id=6eb48072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb48072"]])

export default __exports__